<template>
    <!-- 储值商品配置 -->
    <div>
        <content-view v-show="$utils.renderWhen(this,'storedValue')">
            <a-spin :spinning="loading">
                <div class="wrap-container-in stored-value">
                    <div class="stored-value-header">
                        <a-card :bordered="false" title="储值商品列表" :headStyle="{border: '0px'}">
                            <template slot="extra">
                                <a-button type="primary" @click="toConfig">储值规则设置</a-button>
                            </template>
                            <div class="stored-value-goods-list flex flex-space-between">
                                <div v-for="(item, index) in dataSource" class="stored-value-goods-list-item" :key="item.key">
                                    <a-form :form="item.form">
                                        <div class="stored-value-goods-list-item-content">
                                            <a-form-item class="no-margin_bottom">
                                                <input type="hidden" v-decorator="['id', { initialValue: item.id }]">
                                            </a-form-item>
                                            <div>
                                                <image-uploader :disabled="item.disabled" :value="item.imgUrl" @uploaded="item.uploaded"></image-uploader>
                                            </div>
                                            <a-form-item class="mb8" label="储值卡名称" :label-col="{span: 5}" :wrapper-col="{span: 18}">
                                                <a-input :maxLength="15" :disabled="item.disabled" v-decorator="['name', {initialValue: item.name, rules: [{required: true, message: '请输入'}]}]" placeholder="请输入"/>
                                            </a-form-item>
                                            <a-form-item class="mb8" label="充值金额" :label-col="{span: 5}" :wrapper-col="{span: 18}">
                                                <a-row>
                                                    <a-col :span="22">
                                                        <a-input-number style="width: 240px" :disabled="item.disabled" v-decorator="['amount', {initialValue: item.amount, rules: [{required: true, message: '请输入'}, {pattern: /^([1-9]{1})(\d{0,7})([.]{1}\d{1,2}?)?$/, message: '请输入大于0的数, 且保留2位小数'}]}]"  placeholder="请输入"/>
                                                    </a-col>
                                                    <a-col :span="2">
                                                        <span class="ml8">元</span>
                                                    </a-col>
                                                </a-row>
                                            </a-form-item>
                                            <a-form-item class="mb8" label="上架时间" :label-col="{span: 5}" :wrapper-col="{span: 18}">
                                                <a-radio-group @change="stateChange($event, 'enableState', index)" :disabled="item.disabled" v-decorator="['enableState', {initialValue: item.enableState , rules: [{required: true, message: '请输入'}]}]">
                                                    <a-radio :value="0">暂不设置</a-radio>
                                                    <a-radio :value="1">设置上架时间</a-radio>
                                                </a-radio-group>
                                            </a-form-item>
                                            <a-row>
                                                <a-col :span="8" class="fields-name text-right">
                                                    <span class="mr16">设定至</span>
                                                </a-col>
                                                <a-col :span="16">
                                                    <a-form-item class="mb8" label=" " :colon="false" :label-col="{span: 1}" :wrapper-col="{span: 23}">
                                                        <a-date-picker :disabled="item.disabled || !Boolean(item.enableState)" showTime style="width: 200px;" v-decorator="['startTime', {initialValue: item.startTime, rules: [{required: Boolean(item.enableState), message: '请输入'}]}]" placeholder="年-月-日 时:分:秒"/>
                                                    </a-form-item>
                                                </a-col>
                                            </a-row>
                                            <a-form-item class="mb8" label="下架时间" :label-col="{span: 5}" :wrapper-col="{span: 18}">
                                                <a-radio-group @change="stateChange($event, 'disableState', index)" :disabled="item.disabled" v-decorator="['disableState', {initialValue: item.disableState,  rules: [{required: true, message: '请输入'}]}]">
                                                    <a-radio :value="0">暂不设置</a-radio>
                                                    <a-radio :value="1">设置下架时间</a-radio>
                                                </a-radio-group>
                                            </a-form-item>
                                            <a-row>
                                                <a-col :span="8" class="fields-name text-right">
                                                    <span class="mr16">设定至</span>
                                                </a-col>
                                                <a-col :span="16">
                                                    <a-form-item class="mb8" label=" " :colon="false" :label-col="{span: 1}" :wrapper-col="{span: 23}">
                                                        <a-date-picker :disabled="item.disabled || !Boolean(item.disableState)" showTime style="width: 200px;" v-decorator="['endTime', {initialValue: item.endTime, rules: [{required: Boolean(item.disableState), message: '请输入'}]}]" placeholder="年-月-日 时:分:秒"/>
                                                    </a-form-item>
                                                </a-col>
                                            </a-row>
                                        </div>
                                        <div class="actions flex">
                                            <template v-if="item.disabled">
                                                <a-popconfirm
                                                :title="`是否${item.isEnable ? '下架' : '上架'}?`"
                                                @confirm="changeEnable(index)"
                                                >
                                                    <a class="text-primary" >{{item.isEnable ? '下架' : '上架'}}</a>
                                                </a-popconfirm>
                                                <a-divider type="vertical"></a-divider>
                                                <a class="text-primary" v-if="!item.isEnable" @click="toggleEdit(index, false)">编辑</a>
                                                <a class="text-disabled" v-else>编辑</a>
                                                <a-divider type="vertical"></a-divider>
                                            </template>
                                            <template v-if="!item.disabled">
                                                <a class="text-primary" @click="submit(index)">提交</a>
                                                <a-divider type="vertical"></a-divider>
                                                <template v-if="Boolean(item.id)">
                                                    <a class="text-primary" @click="toggleEdit(index, true)">取消</a>
                                                    <a-divider type="vertical"></a-divider>
                                                </template>
                                            </template>
                                            <a-popconfirm
                                            title="是否删除?"
                                            @confirm="delItem(index)"
                                            v-if="!item.isEnable"
                                            >
                                                <a class="text-primary">删除</a>
                                            </a-popconfirm>
                                            <a class="text-disabled" v-else>删除</a>
                                        </div>
                                    </a-form>
                                </div>
                                <div @click="addItem" class="stored-value-goods-list-item-add flex">
                                    <div class="text-center">
                                        <div class="mb16"><a-icon style="font-size: 32px;" type="plus" /></div>
                                        <div style="font-size: 18px">
                                            新增储值商品
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </a-card>
                    </div>
                </div>
            </a-spin>
        </content-view>
        <router-view></router-view>
    </div>
</template>

<script type="text/javascript">
    import ImageUploader from '@/components/common/image-uploader.component';
    export default {
        name: "storedValue",
        zn: '储值商品设置',
        components: {
            ImageUploader
        },
        props: {},
        data() {
            let that = this;
            return {
                loading: false,
                dataSource: []
            };
        },
        computed: {},
        beforeCreate() {
            this.form = this.$form.createForm(this);
        },
        methods: {
            /**
             * @getStoredValueCard 获取储值卡列表
             */
            getStoredValueCard() {
                if (this.loading) {
                    return false;
                }
                this.loading = true;
                this.$api.totalPlatform.getStoredValueCard({}).then(res => {
                    this.loading = false;
                    this.dataSource = [];
                    res.forEach(i => {
                        this.addItem(i);
                    });
                }).catch(err => {
                    this.loading = false;
                });
            },
            /**
             * @toConfig 跳转储值规则设置
             */
            toConfig() {
                this.$router.push({name: 'storedValueConfig'});
            },
            /**
             * @addItem 新增商品项
             */
            addItem(item = {isEnable: false}) {
                let key = String(this.$moment().valueOf());
                let form = this.$form.createForm(this);
                let moment = this.$moment;
                function createItem() {
                    this.id = item.id || null;
                    this.key = item.id ? key + item.id : key;
                    this.form = form;
                    this.disabled = Boolean(item.id);
                    this.isEnable = item.isEnable;
                    this.enableState = item.id ? Number(Boolean(item.startTime)) : 1;
                    this.disableState = item.id ? Number(Boolean(item.endTime)) : 0;
                    this.oEnableState = item.id ? Number(Boolean(item.startTime)) : 1;
                    this.oDisableState = item.id ? Number(Boolean(item.endTime)) : 1;
                    this.imgUrl = item.imgUrl || '';
                    this.oImgUrl = item.imgUrl || '';
                    this.name = item.name || null;
                    this.price = item.price || null;
                    this.amount = item.amount || null;
                    this.startTime = item.startTime ? moment(item.startTime) : null;
                    this.endTime = item.endTime ? moment(item.endTime) : null;
                    this.uploaded = function(imgUrl) {
                        this.imgUrl = imgUrl;
                    }.bind(this);
                }
                this.dataSource.push(new createItem());
            },
            /**
             * @stateChange 变更上下架时间状态
             */
            stateChange(e, key, index) {
                let val = e.target.value;
                this.dataSource[index][key] = val;
                if (val === 0) {
                    this.dataSource[index].form.setFieldsValue({
                        [key === 'enableState' ? 'startTime' : 'endTime'] : null
                    });
                } else {
                    this.dataSource[index].form.resetFields(key === 'enableState' ? 'startTime' : 'endTime');
                }
            },
            /**
             * @openEdit 设置编辑状态
             */
            toggleEdit(index, val) {
                this.dataSource[index].disabled = val;
                if (val) {
                    this.dataSource[index].form.resetFields();
                    this.dataSource[index].imgUrl = this.dataSource[index].oImgUrl;
                    this.dataSource[index].enableState = this.dataSource[index].oEnableState;
                    this.dataSource[index].disableState = this.dataSource[index].oDisableState;
                }
            },
            /**
             * @delItem 删除商品项
             */
            delItem(index) {
                let { id } = this.dataSource[index];
                if(Boolean(id)) {
                    if (this.loading) {
                        return false;
                    }
                    this.loading = true;
                    this.$api.totalPlatform.delStoredValueCard({
                        params: {
                            id
                        }
                    }).then(res => {
                        this.loading = false;
                        this.getStoredValueCard();
                    }).catch(err => {
                        this.loading = false;
                    });
                } else {
                    this.dataSource.splice(index, 1);
                }
            },
            /**
             * @submit 新增商品
             */
            submit(index) {
                let imgUrl = this.dataSource[index].imgUrl;
                if (!imgUrl) {
                    this.$message.error('商品封面不能为空！');
                    return false;
                }
                this.dataSource[index].form.validateFields((errors, values) => {
                    if (errors || this.loading) {
                        return false;
                    }
                    this.loading = true;
                    values.startTime && (values.startTime = values.startTime.format('YYYY-MM-DD HH:mm:ss'));
                    values.endTime && (values.endTime = values.endTime.format('YYYY-MM-DD HH:mm:ss'));
                    values.imgUrl = imgUrl;
                    delete values.enableState;
                    delete values.disableState;
                    this.$api.totalPlatform[!Boolean(values.id) ? 'addStoredValueCard' : 'editStoredValueCard']({
                        body: {
                            ...values
                        }
                    }).then(res => {
                        this.loading = false;
                        this.getStoredValueCard();
                    }).catch(err => {
                        this.loading = false;
                    });
                });
            },
            /**
             * @changeEnable 上下架商品
             */
            changeEnable(index) {
                if (this.loading) {
                        return false;
                }
                let { id, isEnable } = this.dataSource[index];
                this.$api.totalPlatform[isEnable ? 'disableStoredValueCard' : 'enableStoredValueCard']({
                    params: {
                        id
                    }
                }).then(res => {
                    this.loading = false;
                    this.getStoredValueCard();
                }).catch(err => {
                    this.loading = false;
                });
            }
        },
        created() {
        },
        mounted() {
            this.getStoredValueCard();
        }
    };
</script>
<style lang="scss">
    .stored-value {
        &-goods-list {
            flex-wrap: wrap;
            align-items: flex-start;
            padding: 0 8px;
            &-item {
                width: 45%;
                min-width: 45%;
                border: 1px solid #dddddd;
                margin-bottom: 24px;
                &-content {
                    padding: 8px;
                }
                .ant-upload {
                    width: 100%;
                    height: 256px;
                    img {
                        height: 238px;
                    }
                }
                .fields-name {
                    line-height: 32px;
                    color: rgba(0, 0, 0, 0.85);
                }
                .actions {
                    border-top: 1px solid #dddddd;
                    background: #f8f8f8;
                    padding: 8px 0;
                }
                &-add {
                    width: 45%;
                    min-width: 45%;
                    height: 568px;
                    background: #f8f8f8;
                    border: 1px solid #dddddd;
                    user-select: none;
                    cursor: pointer;
                    margin-bottom: 24px;
                    &:hover {
                        border: 1px solid #ff6d33;
                    }
                }
            }
        }
    }
</style>
